import request from '@/utils/request'
import { v2Host } from '@/config/host'

/**
 * http://localhost:8067/?doc=common/search.go
 * @param {{identifier: string}} data
 * @return {Promise<{}>}
 */
export function commonSearch(data) {
  return request({
    url: `${v2Host}/common/search`,
    method: 'get',
    params: data,
  })
}

/**
 * @param {{keyword: string, search_field:string, type:string}} data
 * @return {Promise<{}>}
 */
export function commonSearchOptions(data) {
  return request({
    url: `${v2Host}/common/search-options`,
    method: 'get',
    params: data,
  })
}

/**
 * @param {{keyword: string}} data
 * @return {Promise<{}>}
 */
export function commonSearchProjects(data) {
  return request({
    url: `${v2Host}/common/search-projects`,
    method: 'get',
    params: data,
  })
}
